import React from "react";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import FAQ from "../components/FAQ";
import "../css/SafariPage.css";
import { Helmet } from "react-helmet-async";
import { faqData } from "../components/FAQ";

export default function CanterSafariPage() {

  const heroImage = "/images/canter-hero.jpg";

  const faqSchema = {

    "@context": "https://schema.org",

    "@type": "FAQPage",

    "mainEntity": faqData.map(faq => ({

      "@type": "Question",

      "name": faq.question,

      "acceptedAnswer": {

        "@type": "Answer",

        "text": faq.answer

      }

    }))

  };

  return (
    <>
<Helmet>

  <title>
    Canter Safari Ranthambore Booking | Zones, Timings & Guide
  </title>

  <meta
    name="description"
    content="Complete guide to Canter Safari Ranthambore including safari zones, timings and booking details."
  />

  <link
    rel="canonical"
    href="https://safariranthamborebooking.com/canter-safari-ranthambore"
  />


    <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>


</Helmet>








      <Header />

      {/* HERO SECTION */}
      <div
        className="safari-hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="safari-overlay" >

          <div className="safari-overlay-canter-jii">
 <h1>Canter Safari Ranthambore – Complete Guide & Information</h1>
 <a href="/" className="bf-button-canter-ji">Plan Your Trip Now</a>

          </div>
         
                  </div>


      </div>


      <div className="safari-container">


        {/* INTRO SECTION */}
        <div className="highlight-box">

          <h2>Explore Ranthambore National Park with Canter Safari</h2>

          <p>
            Canter Safari is a 20-seater open safari vehicle operated by the forest department.
            It provides an affordable and exciting wildlife experience in Ranthambore National Park.
            This safari is ideal for groups and offers excellent opportunities to spot tigers,
            leopards, deer, and other wildlife.
          </p>

        </div>


        {/* VEHICLE IMAGE */}
        <img
          src="/images/canter-vehicle.jpg"
          className="section-image"
          alt="Canter Safari Vehicle Ranthambore"
        />

        <p className="image-caption">
          Canter Safari vehicle used in Ranthambore National Park
        </p>


        {/* INFO GRID */}
        <div className="info-grid">

          <div className="info-item">
            <strong>Vehicle Type</strong>
            <p>20-Seater Open Canter</p>
          </div>

          <div className="info-item">
            <strong>Safari Duration</strong>
            <p>3.5 Hours Approx</p>
          </div>

          <div className="info-item">
            <strong>Guide</strong>
            <p>Professional Forest Guide Included</p>
          </div>

          <div className="info-item">
            <strong>Best For</strong>
            <p>Groups & Budget Travelers</p>
          </div>

        </div>


        {/* FOREST IMAGE */}
        <img
          src="/images/ranthambore-forest.jpg"
          className="section-image"
          alt="Ranthambore Forest Safari"
        />

        <p className="image-caption">
          Wildlife and forest environment inside Ranthambore National Park
        </p>


        {/* SAFARI TIMINGS */}
        <div className="safari-section">

          <h2>Canter Safari Timings</h2>

          <div className="safari-card">

            <ul>
              <li>Morning Safari: 6:30 AM – 10:00 AM</li>
              <li>Afternoon Safari: 2:30 PM – 6:00 PM</li>
              <li>Timings vary depending on season</li>
              <li>Safari duration is approximately 3.5 hours</li>
            </ul>

          </div>

        </div>


        {/* TIGER IMAGE */}
        <img
          src="/images/ranthambore-tiger.jpg"
          className="section-image"
          alt="Tiger sighting in Ranthambore"
        />

        <p className="image-caption">
          Tiger sighting during Canter Safari in Ranthambore
        </p>


        {/* ZONES SECTION */}
        <div className="safari-section">

          <h2>Safari Zones Covered</h2>

          <div className="safari-card">

            <p>
              Ranthambore National Park has 10 safari zones. Canter Safari mainly operates in
              Zones 1 to 5, which have high tiger sighting probability.
            </p>

            <ul>
              <li>Zone 1 – Dense forest and tiger territory</li>
              <li>Zone 2 – High wildlife activity</li>
              <li>Zone 3 – Famous for tiger sightings and lakes</li>
              <li>Zone 4 – Scenic forest zone</li>
              <li>Zone 5 – Excellent tiger sightings</li>
            </ul>

          </div>

        </div>


        {/* ZONE MAP */}
        <div className="safari-section">

          <h2>Ranthambore Safari Zone Map</h2>

          <img
            src="/images/ranthambore-zone-map.jpg"
            className="section-image"
            alt="Ranthambore Zone Map"
          />

          <p className="image-caption">
            Map showing safari zones in Ranthambore National Park
          </p>

        </div>


        {/* GALLERY */}
        <div className="gallery-container">

          <h2>Canter Safari Gallery</h2>

          <div className="gallery-slider">

            <img src="/images/gallery1.jpg" alt="Canter Safari Ranthambore" />

            <img src="/images/gallery2.jpg" alt="Tiger Ranthambore Safari" />

            <img src="/images/gallery3.jpg" alt="Forest Ranthambore Safari" />

            <img src="/images/gallery4.jpg" alt="Wildlife Ranthambore Safari" />

          </div>

        </div>


        {/* FAQ SECTION */}
        <FAQ />


        


      </div>

    </>
  );
}
